'use client'

import { useState } from 'react'
import { Image } from '@/lib/next-shim'

import { FilePreviewDialog } from '@/shared/ui/dialog/FilePreviewDialog'

import type { FileProp } from '../model/types'
import { getExtension, getPreviewSrc } from '../lib/filePreview'

type DocumentsSectionProps = {
  file: FileProp
}

export function Document(props: DocumentsSectionProps) {
  const { file } = props

  const [openFilePreview, setOpenFilePreview] = useState<boolean>(false)

  return (
    <>
      <div onClick={() => setOpenFilePreview(true)} className="relative" data-testid="document-card">
        <div className="cursor-pointer group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
          <Image
            src={getPreviewSrc(file)}
            alt={file.filename}
            className="h-full w-full pointer-events-none object-cover group-hover:opacity-75"
            width={100}
            height={150}
          />
        </div>
        <p className="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">{file.filename}</p>
      </div>
      <FilePreviewDialog
        fileName={file.filename}
        fileType={getExtension(file.filename)}
        onClose={() => setOpenFilePreview(false)}
        open={openFilePreview}
        src={file.url}
      />
    </>
  )
}
